import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { 
  MatProgressBarModule, 
  MatDialogModule, 
  MatMenuModule, 
  MatDatepickerModule, 
  MatNativeDateModule, 
  MatPaginatorModule, 
  MatInputModule, 
  MatTooltipModule, 
  MatSlideToggleModule, 
  MatSelectModule, 
  MatFormFieldModule, 
  MatProgressSpinnerModule,
  MatTableModule,
  MatButtonModule,
  MatIconModule,
  MatCardModule,
  MatChipsModule,
  MatExpansionModule
} from '@angular/material';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    MatProgressBarModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatInputModule,
    MatMenuModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatChipsModule,
    MatExpansionModule
  ]
})
export class MaterialModule { }
